import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Confirmation';
  @Input() message: string = 'Êtes-vous sûr de vouloir continuer ?';
  @Input() confirmText: string = 'Confirmer';
  @Input() cancelText: string = 'Annuler';
  @Input() type: 'danger' | 'warning' | 'info' = 'info';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
    this.close.emit();
  }

  onCancel(): void {
    this.cancel.emit();
    this.close.emit();
  }

  onClose(): void {
    this.close.emit();
  }

  getIconClass(): string {
    switch (this.type) {
      case 'danger':
        return 'warning_amber';
      case 'warning':
        return 'warning_amber';
      case 'info':
      default:
        return 'info';
    }
  }

  getIconWrapperClass(): string {
    switch (this.type) {
      case 'danger':
        return 'confirmation-icon-danger';
      case 'warning':
        return 'confirmation-icon-warning';
      case 'info':
      default:
        return 'confirmation-icon-info';
    }
  }

  getConfirmButtonClass(): string {
    switch (this.type) {
      case 'danger':
        return 'confirmation-btn-danger';
      case 'warning':
        return 'confirmation-btn-warning';
      case 'info':
      default:
        return 'confirmation-btn-confirm';
    }
  }

  getConfirmIconClass(): string {
    switch (this.type) {
      case 'danger':
        return 'delete_forever';
      case 'warning':
        return 'warning_amber';
      case 'info':
      default:
        return 'check_circle';
    }
  }

  getButtonClass(): string {
    switch (this.type) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 focus:ring-red-500';
      case 'warning':
        return 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500';
      case 'info':
      default:
        return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500';
    }
  }
} 